import Configuration from '@/agilis/util/Configuration'
import DataTableV2Title from '@/agilis/components/DataTableV2/DataTableV2Title/DataTableV2Title.vue'
import configurationMixin from '@/agilis/components/DataTableV2/common/configurationMixin'
import renderMixin from '@/agilis/components/DataTableV2/common/renderMixin'
import viewMixin from '@/agilis/components/DataTableV2/common/viewMixin'
import linkToMixin from '@/agilis/components/DataTableV2/common/linkToMixin'

export default {
  name: 'DataTableV2ImportResult',
  mixins: [
    configurationMixin,
    renderMixin,
    viewMixin,
    linkToMixin
  ],

  props: {
    title: String,
    description: String,
    items: Array
  },

  components: {
    DataTableV2Title
  },

  computed: {
    decoratedItems () {
      return Configuration.datatable.decorateItems(this.configuration, this.items)
    }
  }
}
